<div class="g-menu w-[264px]">
  <div class="g-menu-search">
    <i [class]="ICONS.magnifyingGlass"></i>
    <input
      type="text"
      [value]="searchQuery()"
      [placeholder]="'filters.search_filters' | translate"
      (input)="updateSearch($any($event.target).value)" />
    @if (searchQuery()) {
      <button
        type="button"
        class="text-text-tertiary hover:text-text-primary flex shrink-0 cursor-pointer items-center text-xs"
        [attr.aria-label]="'common.clear' | translate"
        (click)="updateSearch('')">
        <i [class]="ICONS.x"></i>
      </button>
    }
  </div>

  <div class="g-menu-scroll">
    @if (availableFieldsToShow().length === 0) {
      <p class="g-menu-empty">{{ 'filters.no_filters_found' | translate }}</p>
    } @else {
      @for (field of availableFieldsToShow(); track trackByField(field)) {
        <button
          type="button"
          data-field-item
          class="g-menu-item w-full"
          [title]="field.label"
          (click)="addFilter(field)">
          <i [class]="getDataTypeIcon(field.dataType)"></i>
          <span class="ellipsis">{{ field.label }}</span>
        </button>
      }
    }
  </div>

  @if (displayComplexFilterOption()) {
    <div class="g-menu-divider"></div>

    <button type="button" class="g-menu-item w-full" (click)="addComplexFilter()">
      <i [class]="ICONS.funnel"></i>
      <span class="ellipsis">{{ 'filters.add_complex_filter' | translate }}</span>
    </button>

    <p class="g-menu-note">
      {{ 'filters.add_complex_filter_description' | translate }}
    </p>
  }
</div>
